import { Select } from '@/components/atoms/Select';

type BusinessesContactedSelectorProps = {
	selectedMethod?: string;
	onUpdateMethods: (value: string | undefined) => void;
};

export const BusinessesContactedSelector = ({
	selectedMethod,
	onUpdateMethods
}: BusinessesContactedSelectorProps) => {
	const clearSelectionValue = 'all-methods'; // That's important to remove the selected method when selecting the all methods option

	const handleUpdateMethod = (value: string) => {
		const method = value === clearSelectionValue ? undefined : value;

		onUpdateMethods(method);
	};

	return (
		<Select.Root
			onValueChange={handleUpdateMethod}
			defaultValue={clearSelectionValue}
			value={selectedMethod || clearSelectionValue}
		>
			<Select.Trigger className="w-full max-w-48 border-orange font-semibold text-orange [&_path]:fill-orange">
				<Select.Value placeholder="Methods" />
			</Select.Trigger>

			<Select.Content>
				<Select.Item value={clearSelectionValue}>
					All methods
				</Select.Item>
				<Select.Item value="email">By email</Select.Item>
				<Select.Item value="facebook">By Facebook</Select.Item>
				<Select.Item value="instagram">By Instagram</Select.Item>
				<Select.Item value="phone">By phone</Select.Item>
			</Select.Content>
		</Select.Root>
	);
};
